"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const query_string_1 = require("query-string");
const emotion_1 = require("emotion");
const styled_1 = __importDefault(require("@emotion/styled"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const useIsInBeta_1 = require("../../hooks/useIsInBeta");
const useRecentItems_1 = __importDefault(require("../../hooks/useRecentItems"));
const ExpandableSection_1 = __importDefault(require("../ExpandableSection"));
const Icon_1 = __importDefault(require("../Icon"));
const canDo_1 = __importDefault(require("../../utils/canDo"));
const getPath_1 = __importDefault(require("../../utils/getPath"));
const isInternalUser_1 = __importDefault(require("../../utils/isInternalUser"));
const memoize_1 = __importDefault(require("../../utils/memoize"));
const AtmsApiClient_1 = __importDefault(require("../../utils/AtmsApiClient"));
const setupI18n_1 = __importDefault(require("../../utils/setupI18n"));
const Link_1 = require("./Link");
const CreateNewButton_1 = __importDefault(require("./CreateNewButton"));
const useSession_1 = require("../../hooks/useSession");
const inferEnvironment_1 = __importDefault(require("../../utils/inferEnvironment"));
const et_client_metrics_1 = require("@amzn/et-client-metrics");
const environment = inferEnvironment_1.default();
const initialMetricsPublisher = et_client_metrics_1.makePublisherWithDefaultDriver('ATMS', 'ETConsoleComponents-TmsNav', environment);
const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const buildPathRegex = memoize_1.default(paths => {
    if (!paths.length) {
        return null;
    }
    return new RegExp('^(' +
        paths
            .map(path => {
            if (path.endsWith('$')) {
                return escapeRegExp(path.substring(0, path.length - 1)) + '$';
            }
            else {
                return escapeRegExp(path) + '(/|$|\\?)';
            }
        })
            .join('|') +
        ')');
});
const Search = react_router_1.withRouter(({ location: { pathname, search }, history }) => {
    const [value, setValue] = react_1.useState(`${query_string_1.parse(search).q || ''}`);
    react_1.useEffect(() => {
        setValue(`${query_string_1.parse(search).q || ''}`);
    }, [pathname, search]);
    return (react_1.default.createElement("form", { onSubmit: e => {
            e.preventDefault();
            history.push(`/web/search/index?q=${encodeURIComponent(value)}`);
        } },
        react_1.default.createElement(polaris_1.Input, { label: setupI18n_1.default.t('Search'), placeholder: setupI18n_1.default.t('Project, Job, User, etc.'), type: "search", value: value, onInput: ({ detail: { value } }) => setValue(value) })));
});
const withIconAndEllipsis = (Component) => {
    return ({ children, className, icon, ...props }) => (react_1.default.createElement(Component, Object.assign({}, props, { className: emotion_1.cx(emotion_1.css({
            display: 'inline-flex',
            alignItems: 'center',
            maxWidth: '100%',
            '& svg': {
                height: '16px',
                width: '16px',
                marginRight: '0.5em',
                flexShrink: 0,
            },
            '& .awsui-icon': {
                marginRight: '0.5em',
            },
        }), className) }),
        react_1.default.createElement(react_1.default.Fragment, null,
            icon && react_1.default.createElement(Icon_1.default, { name: icon }),
            react_1.default.createElement("span", { className: emotion_1.css({
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    maxWidth: '100%',
                }) }, children))));
};
const withLinkStyles = (Component) => {
    return (props) => (react_1.default.createElement(Component, Object.assign({}, props, { className: emotion_1.cx(emotion_1.css({
            '.awsui &': {
                color: '#879596',
                fontWeight: 400,
                textDecoration: 'none',
            },
            '.awsui &:hover': {
                color: '#879596',
                textDecoration: 'underline',
            },
            '& *': {
                cursor: 'pointer',
            },
        }), props.className) })));
};
const ExternalLink = withIconAndEllipsis(withLinkStyles(({ children, ...props }) => react_1.default.createElement("a", Object.assign({}, props), children)));
const BaseLink = withIconAndEllipsis(withLinkStyles(Link_1.Link));
const NavLink = withIconAndEllipsis(withLinkStyles(react_router_1.withRouter(({ location, paths = [], className, ...props }) => {
    const regex = buildPathRegex(paths);
    const path = getPath_1.default(location);
    const isActive = regex ? regex.test(path) : path === props.to;
    return (react_1.default.createElement(Link_1.Link, Object.assign({ className: emotion_1.cx(className, isActive && 'nav-link--active', isActive &&
            emotion_1.css({
                // more specific selector to ensure it overrides the fontWeight (type definition doesn't allow `!important` keyword)
                '* .awsui &': {
                    fontWeight: 'bold',
                    color: '#ec7211 !important',
                },
            })) }, props)));
})));
/**
 Bold NavLink
 */
const PrimaryNavLink = props => (react_1.default.createElement(NavLink, Object.assign({ className: emotion_1.css({
        color: '#16191f !important',
        'a&': {
            fontWeight: 400,
            color: '#879596',
            textDecoration: 'none',
        },
        '&:hover': {
            color: '#ec7211 !important',
        },
        '&:hover, &:active, &:focus': {
            textDecoration: 'none !important',
        },
    }) }, props)));
const NavBox = styled_1.default.section({
    lineHeight: '2rem',
    minHeight: '100%',
    '.awsui & .awsui-expandable-section-header-icon': {
        margin: '0 0.5em 0 0',
    },
    '.awsui & .awsui-expandable-section-header': {
        color: '#879596',
    },
});
const NavHeader = ({ title, url, logo, organizationName }) => {
    return (react_1.default.createElement("div", { className: emotion_1.css({
            '& h2, & h2 a': {
                fontWeight: 700,
                fontSize: '18px',
                color: '#16191f !important',
            },
            '& h2': {
                padding: '20px 40px 20px 30px',
                margin: '0',
            },
        }) },
        react_1.default.createElement("h2", null,
            react_1.default.createElement(BaseLink, { to: url }, logo ? (react_1.default.createElement("img", { height: "43", src: `/web/logo/show/${logo}`, alt: title, title: title })) : (title)),
            organizationName === 'ASINLoc' && (react_1.default.createElement("div", { className: emotion_1.css({
                    '& span': {
                        padding: '15px 0 0 0',
                    },
                    '& span, & span a': {
                        display: 'inline-block',
                        fontWeight: 400,
                        fontSize: '13px',
                    },
                    '& span a': {
                        color: '#0073bb !important',
                    },
                }) },
                react_1.default.createElement("span", null,
                    "Amazon Europe Core Sarl of LUX 18 (38 avenue John F. Kennedy, L-1855 Luxembourg) is a data controller of information provided to or collected by it, including through ATMS. Such information will be processed in accordance with the",
                    ' ',
                    react_1.default.createElement(Link_1.Link, { to: "/privacyPolicy", target: "_blank", rel: "noopener noreferrer" }, "ATMS privacy policy"),
                    "."))))));
};
const NavSection = styled_1.default.div({
    borderTop: '1px solid #d5dbdb',
    padding: '20px 30px',
    '.awsui & li': {
        margin: '10px 0',
    },
});
const NavGroup = styled_1.default.ul({
    listStyle: 'none',
    padding: '0 !important',
    margin: '0 !important',
});
const NavItem = styled_1.default.li({
    padding: '0 !important',
    margin: '10px 0 !important',
});
const HelpSection = ({ session }) => {
    const isInternal = isInternalUser_1.default(session);
    return isInternal ? (react_1.default.createElement(NavSection, null,
        react_1.default.createElement(NavGroup, null,
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(ExternalLink, { href: "https://w.amazon.com/index.php/ATMS/User_Guide", rel: "noopener noreferrer", target: "_blank", icon: "MdLibraryBooks", translate: "yes" }, "User Manual")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(NavLink, { to: '/privacyPolicy', icon: "MdLibraryBooks", translate: "yes" }, "Privacy Policy"))))) : (react_1.default.createElement(NavSection, null,
        react_1.default.createElement(NavGroup, null,
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(NavLink, { to: '/privacyPolicy', icon: "MdLibraryBooks", translate: "yes" }, "Privacy Policy")))));
};
const TmsNavLinguist = react_router_1.withRouter(({ location: { pathname, search }, history, session }) => {
    var _a, _b, _c;
    const [projectCounts, setProjectCounts] = react_1.useState({});
    const [selectedStatus, setSelectedStatus] = react_1.useState('NEW');
    const [showATMSTicketsLink, setShowAtmsTicketsLink] = react_1.useState(false);
    const { isInBeta: isInLinguistJobListBeta, setIsInBeta: setIsInLinguistJobListBeta, } = useIsInBeta_1.useIsInBeta('LinguistJobList');
    react_1.useEffect(() => {
        const countAPI = isInLinguistJobListBeta
            ? '/web/api/v9/job/getJobCounts'
            : '/web/api/v3/project/getProjectCounts';
        AtmsApiClient_1.default.httpPost(countAPI)
            .then(result => {
            setProjectCounts(result);
        })
            .catch(err => {
            console.warn(`${setupI18n_1.default.t('Failed to get project counts')}: ${err}`);
        });
    }, [pathname, search]);
    react_1.useEffect(() => {
        const actionMetricsPublisher = et_client_metrics_1.publishCountForMethod(initialMetricsPublisher, 'LinguistNavLoad');
        actionMetricsPublisher.publishCounter('IsInLinguistJobListBeta', isInLinguistJobListBeta ? 1 : 0);
    }, [isInLinguistJobListBeta]);
    react_1.useEffect(() => {
        AtmsApiClient_1.default.httpGet('/web/tickets/api/access')
            .then(() => {
            setShowAtmsTicketsLink(true);
        })
            .catch(() => {
            setShowAtmsTicketsLink(false);
        });
    }, []);
    const statusPathname = isInLinguistJobListBeta ? '/web/job/list' : '/web/project/list';
    react_1.useEffect(() => {
        const query = query_string_1.parse(search);
        if (query.listStatus) {
            setSelectedStatus(query.listStatus);
        }
    }, [search, setSelectedStatus]);
    const statuses = {
        NEW: { name: setupI18n_1.default.t('New'), count: projectCounts.NEW, badgeColor: 'red' },
        ASSIGNED: { name: setupI18n_1.default.t('Accepted'), count: projectCounts.ASSIGNED },
        COMPLETED_BY_LINGUIST: {
            name: setupI18n_1.default.t('Completed'),
            count: ((_a = projectCounts.COMPLETED_BY_LINGUIST) !== null && _a !== void 0 ? _a : 0) + ((_b = projectCounts.COMPLETED) !== null && _b !== void 0 ? _b : 0),
        },
    };
    const handleLinguistJobListBetaChange = (e) => {
        setIsInLinguistJobListBeta(e.detail.checked).then(result => {
            history.push(`${result ? '/web/job/list' : '/web/project/list'}${search}`);
        });
    };
    return (react_1.default.createElement(NavBox, null,
        react_1.default.createElement(NavHeader, { logo: (_c = session.organization.logo) === null || _c === void 0 ? void 0 : _c.name, title: session.organization.name, organizationName: session.organization.name, url: "/web" }),
        react_1.default.createElement(NavSection, null,
            react_1.default.createElement(polaris_1.Toggle, { id: "new-job-list-experience-toggle", checked: isInLinguistJobListBeta, onChange: handleLinguistJobListBetaChange, description: react_1.default.createElement("a", { href: '/web/tickets/list/createTicket?linguistListBeta=true' }, setupI18n_1.default.t('Let us know about a problem')) }, "New job list experience for linguists")),
        react_1.default.createElement(NavSection, null,
            react_1.default.createElement(NavGroup, null,
                Object.keys(statuses).map(status => (react_1.default.createElement(NavItem, { key: status },
                    react_1.default.createElement(PrimaryNavLink, { to: `${statusPathname}?listStatus=${status}`, paths: [`${statusPathname}?listStatus=${status}`].concat(selectedStatus === status
                            ? [statusPathname, '/web/project2', '/web/analyse']
                            : []) },
                        statuses[status].name,
                        ' ',
                        statuses[status].count > 0 && (react_1.default.createElement(polaris_1.Badge, { color: statuses[status].badgeColor || 'grey', content: statuses[status].count })))))),
                react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/web/setup/index", paths: ['/web/setup'] }, "Setup"))),
            react_1.default.createElement(NavGroup, null, showATMSTicketsLink && (react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/tickets/list", paths: ['/web/tickets'], icon: "edit", translate: "yes" }, "Contact Us"))))),
        react_1.default.createElement(HelpSection, { session: session })));
});
const TmsNavSysadmin = ({ session }) => (react_1.default.createElement(NavBox, null,
    react_1.default.createElement(NavHeader, { title: setupI18n_1.default.t('Sysadmin'), url: "/web" }),
    react_1.default.createElement(NavSection, null,
        react_1.default.createElement(NavGroup, null,
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/organization/list", paths: ['/web/organization'], translate: "yes" }, "Organizations")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/userAdmin/list", paths: ['/web/userAdmin/list', '/web/userAdmin/edit'], translate: "yes" }, "Users")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/edition/list", paths: ['/web/edition'], translate: "yes" }, "Editions")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/supportedFileFormat/list", paths: ['/web/supportedFileFormat'], translate: "yes" }, "File Types")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/systemInfo/show", paths: ['/web/systemInfo'], translate: "yes" }, "System Info")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/emailTemplate/list", paths: ['/web/emailTemplate'], translate: "yes" }, "Email Templates")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/userAdmin/listSysAdmin", paths: ['/web/userAdmin/listSysAdmin', '/web/userAdmin/editSysAdmin'], translate: "yes" }, "Sysadmins")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/internals/index", paths: ['/web/internals'], translate: "yes" }, "Internals")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/configurationProperty/list", paths: ['/web/configurationProperty'], translate: "yes" }, "Configuration Properties")),
            react_1.default.createElement(NavItem, null,
                react_1.default.createElement(PrimaryNavLink, { to: "/web/throttleProperty/list", paths: ['/web/throttleProperty'], translate: "yes" }, "Throttle Properties")))),
    react_1.default.createElement(HelpSection, { session: session })));
const TmsNavAdmin = ({ session }) => {
    var _a;
    const [recentItems] = useRecentItems_1.default(session.user.id);
    const [showATMSTicketsLink, setShowAtmsTicketsLink] = react_1.useState(false);
    react_1.useEffect(() => {
        AtmsApiClient_1.default.httpGet('/web/tickets/api/access')
            .then(() => {
            setShowAtmsTicketsLink(true);
        })
            .catch(() => {
            setShowAtmsTicketsLink(false);
        });
    }, []);
    const [showsATMSInvoicesLink, setShowAtmsInvoicesLink] = react_1.useState(false);
    react_1.useEffect(() => {
        AtmsApiClient_1.default.httpGet('/invoices/api/submitInvoice/access')
            .then(() => {
            setShowAtmsInvoicesLink(true);
        })
            .catch(() => {
            setShowAtmsInvoicesLink(false);
        });
    }, []);
    return (react_1.default.createElement(NavBox, null,
        react_1.default.createElement(NavHeader, { logo: (_a = session.organization.logo) === null || _a === void 0 ? void 0 : _a.name, title: session.organization.name, organizationName: session.organization.name, url: "/web" }),
        react_1.default.createElement(NavSection, null,
            react_1.default.createElement(NavGroup, null,
                react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/web/project/list", paths: ['/web/project', '/web/project2', '/web/job', '/web/analyse'], icon: Icon_1.default.for('project'), translate: "yes" }, "Projects")),
                canDo_1.default(session, ['transMemory:create', 'transMemory:viewOther']) && (react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/web/transMemory/list", paths: ['/web/transMemory'], icon: Icon_1.default.for('transmemory'), translate: "yes" }, "Translation Memories"))),
                canDo_1.default(session, ['termBase:create', 'termBase:viewOther']) && (react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/web/termBase", paths: ['/web/termBase', '/tb'], icon: Icon_1.default.for('termbase'), translate: "yes" }, "Term Bases"))),
                canDo_1.default(session, ['user:create', 'user:viewOther']) && (react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/web/user/list", paths: ['/web/user'], icon: "MdPerson", translate: "yes" }, "User Profiles"))),
                react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/web/setup/index", paths: [
                            '/web/setup',
                            '/web/logo',
                            '/web/organization',
                            '/web/organizationEmailTemplate',
                            '/web/vendor',
                            '/web/segRule',
                            '/web/workflowStep',
                            '/web/businessUnit',
                            '/web/client',
                            '/web/costCenter',
                            '/web/domain',
                            '/web/subDomain',
                            '/web/automationWidget',
                            '/web/dueDateScheme',
                            '/web/projectTemplate',
                            '/web/service',
                            '/web/kibanaAccess',
                            '/web/report',
                            '/web/machineTranslateSettings',
                        ], icon: "settings", translate: "yes" }, "Setup")),
                showsATMSInvoicesLink && (react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/invoices/submit", paths: ['/invoices'], icon: "MdAssignment", translate: "yes" }, "Invoices"))),
                showATMSTicketsLink && (react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(PrimaryNavLink, { to: "/web/tickets/list", paths: ['/web/tickets'], icon: "edit", translate: "yes" }, "Contact Us"))))),
        react_1.default.createElement(NavSection, null,
            react_1.default.createElement(NavGroup, null,
                canDo_1.default(session, CreateNewButton_1.default.permissions) && (react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(CreateNewButton_1.default, { session: session }))),
                react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(Search, null)),
                recentItems.length > 0 && (react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(ExpandableSection_1.default, { variant: "navigation", rememberKey: "recentItems", header: setupI18n_1.default.t('Recent Items') },
                        react_1.default.createElement(NavGroup, null, recentItems.map(({ path, type, name }) => (react_1.default.createElement(NavItem, { key: path },
                            react_1.default.createElement(NavLink, { to: path, title: name, icon: Icon_1.default.for(type) }, name)))))))))),
        react_1.default.createElement(HelpSection, { session: session }),
        react_1.default.createElement(NavSection, null,
            react_1.default.createElement(NavGroup, null,
                react_1.default.createElement(NavItem, null,
                    react_1.default.createElement(NavLink, { to: "/web/recycleBin/index", paths: ['/web/recycleBin'], icon: "MdDelete", translate: "yes" }, "Recycle Bin"))))));
};
exports.default = () => {
    var _a;
    const session = useSession_1.useSession();
    // ideally the caller wouldn't try to render us without a session, but just to be safe 🤞
    if (!session.user)
        return null;
    switch ((_a = session === null || session === void 0 ? void 0 : session.user) === null || _a === void 0 ? void 0 : _a.role) {
        case 'ADMIN':
        case 'PROJECT_MANAGER':
            return react_1.default.createElement(TmsNavAdmin, { session: session });
        case 'SYS_ADMIN':
        case 'SYS_ADMIN_READ':
            return react_1.default.createElement(TmsNavSysadmin, { session: session });
        default:
            return react_1.default.createElement(TmsNavLinguist, { session: session });
    }
};
//# sourceMappingURL=index.js.map